/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// INFRASTRUCTURE START
  export type StandardError = globalThis.Error;
  export type Error500s = 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 510 | 511;
  export type ErrorStatuses = 0 | Error500s;
  export type ErrorResponse = FetchResponse<unknown, ErrorStatuses>;

  export type FetchResponseOfError = {
    data: null;
    error: StandardError;
    status: ErrorStatuses;
    args: FetchArgs;
  };

  export type FetchResponseOfSuccess<TData, TStatus extends number = 0> = 
  {
    data: TData;
    error: null;
    status: TStatus;
    args: FetchArgs;
    responseHeaders: Headers;
  };

  export type FetchResponse<TData, TStatus extends number = 0> = 
    TStatus extends ErrorStatuses ? FetchResponseOfError: FetchResponseOfSuccess<TData, TStatus>;

  export type TerminateRequest = null;
  export type TerminateResponse = null;

  export type Configuration = {
    apiUrl: string | (() => string);
    jwtKey: string | undefined | (() => string | null | undefined);
    requestMiddlewares?: Array<{
      name: string;
      fn: (request: FetchArgs) => FetchArgs | TerminateRequest;
    }>;
    responseMiddlewares?: Array<{
      name: string;
      fn: <TData, TStatus extends number>(
        response: FetchResponse<TData, TStatus>,
      ) => FetchResponse<TData, TStatus> | TerminateResponse;
    }>;
  };

  let CONFIG: Configuration = {
    apiUrl: () => "",
    jwtKey: undefined,
    requestMiddlewares: [],
    responseMiddlewares: [],
  };

  export function setupClient(configuration: Configuration) {
    const uniqMiddlewares = <
      T extends
        | Configuration["requestMiddlewares"]
        | Configuration["responseMiddlewares"],
    >(
      oldMiddlewares: T,
      newMiddlewares: T,
    ): T => {
      return [
        ...(oldMiddlewares?.filter(
          middleware => !newMiddlewares?.some(m => m.name === middleware.name),
        ) ?? []),
        ...(newMiddlewares ?? []),
      ] as T;
    };
  
    CONFIG = {
      ...CONFIG,
      ...configuration,
      requestMiddlewares: uniqMiddlewares(CONFIG.requestMiddlewares, configuration.requestMiddlewares),
      responseMiddlewares: uniqMiddlewares(CONFIG.responseMiddlewares, configuration.responseMiddlewares),
    };
  }

  export function getApiUrl() {
    if (typeof CONFIG.apiUrl === "function") {
      return CONFIG.apiUrl();
    }
    return CONFIG.apiUrl;
  }

  export type Termination = {
    termination: {
      name: string;
    };
  };

  export function processRequestWithMiddlewares(
    request: FetchArgs
  ): FetchArgs | Termination {
    for (const middleware of CONFIG.requestMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(request);
        if (middlewareResponse === null) {
          return { termination: { name: middleware.name } };
        }
        request = middlewareResponse;
      } catch (e) {
        console.error("Request middleware error", e);
      }
    }
    return request;
  }

  export function processResponseWithMiddlewares<TData, TStatus extends number>(
    response: FetchResponse<TData, TStatus>,
  ): FetchResponse<TData, TStatus | 0> {
    for (const middleware of CONFIG.responseMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(response);
        if (middlewareResponse === null) {
          return {
            status: 0,
            args: response.args,
            data: null,
            error: new Error(
              `Response terminated by middleware: ${middleware.name}`
            ),
          } satisfies FetchResponseOfError;
        }
        response = middlewareResponse;
      } catch (e) {
        console.error("Response middleware error", e);
      }
    }
    return response;
  }

  export type FetchArgsOptions = Omit<RequestInit, "method" | "redirect" | "body">;

  export type FetchArgs = {
    url: string;
    options: RequestInit;
  }

  export type UriComponent = string | number | boolean;
  export type ParamsObject = {
    [key: string]: UriComponent | UriComponent[] | undefined | null;
  };

  export async function fetchJson<TData>(args: FetchArgs): Promise<FetchResponse<TData, number> | FetchResponseOfError> {
    const errorResponse = (error: StandardError, status: number, args: FetchArgs) => {  
      const errorResponse = {
        status: status as ErrorStatuses,
        args,
        data: null,
        error,
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    const errorStatus = (args: FetchArgs) => {
      const errorResponse = {
        status: 0,
        args,
        data: null,
        error: new Error("Network error"),
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    try {
      const fetchRequest = processRequestWithMiddlewares(args);

      if ("termination" in fetchRequest) {
        const terminationResponse = {
          status: 0,
          args,
          data: null,
          error: new Error(
            `Request terminated by middleware: ${fetchRequest.termination.name}`
          ),
        } satisfies FetchResponseOfError;

        return processResponseWithMiddlewares(terminationResponse);
      }

      const fetchResponse: Response = await fetch(fetchRequest.url, fetchRequest.options);
      const status = fetchResponse.status;
      try {
        const json = await fetchResponse.json();
        const response = {
          data: json,
          status: fetchResponse.status,
          args,
          error: null,
          responseHeaders: fetchResponse.headers,
        };
        return processResponseWithMiddlewares(response);
      } catch (error) {
        return errorResponse(error as StandardError, status, args);
      }
    } catch {
      return errorStatus(args);
    }
  }

  export function getJwtKey(): string | null | undefined {
    if (typeof CONFIG.jwtKey === "function") {
      return CONFIG.jwtKey();
    }

    if (typeof CONFIG.jwtKey === "string") {
      return localStorage.getItem(CONFIG.jwtKey);
    }

    return undefined;
  } 
  
  
 function getApiRequestData<Type extends any>(
    requestContract: Type | undefined,
    isFormData: boolean = false
  ): FormData | Type | {} {
  
    if (!isFormData) {
      return requestContract !== undefined ? requestContract : {};
    }
  
    //multipart/form-data
    const formData = new FormData();
  
     if (requestContract) {
      Object.keys(requestContract).forEach(key => {
        const value = requestContract[key as keyof Type];
        const isKeyArrayAndValueIterable = key.endsWith('[]') && typeof (value as any)[Symbol.iterator] === 'function';
        const values = isKeyArrayAndValueIterable ? Array.from(value as Iterable<any>) : [value];
          for (const val of values) {
              if (val === undefined) {
                  continue;
              }
              if (val === null) {
                  formData.append(key, '');
              } else if (val instanceof File) {
                  formData.append(key, val);
              } else if (typeof val === 'object' && val !== null) {
                  formData.append(key, JSON.stringify(val));
              } else {
                  formData.append(key, val);
              }
          }
      });
    }
  
    return formData;
  }

  
function updateHeaders(headers: HeadersInit) {
  const token = getJwtKey();
  if (headers instanceof Headers) {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    if (!headers.has("Authorization") && !!token) {
      headers.append("Authorization", token);
    }
    return;
  }

  if (Array.isArray(headers)) {
    if (!headers.find(([key]) => key === "Content-Type")) {
      headers.push(["Content-Type", "application/json"]);
    }
    if (!headers.find(([key]) => key === "Authorization") && !!token) {
      headers.push(["Authorization", token]);
    }
    return;
  }

  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (!headers.Authorization && !!token) {
    headers.Authorization = token;
  }
}

function removeContentTypeHeader(headers: HeadersInit) {
  if (headers instanceof Headers) {
    headers.delete("Content-Type");
    return;
  }

  if (Array.isArray(headers)) {
    return headers.filter(([key]) => key !== "Content-Type");
  }

  delete headers["Content-Type"];
}

export function createRequest<TRequest>(
  method: string,
  request: TRequest | undefined,
  options: FetchArgsOptions | undefined,
  url: string,
  paramsObject: ParamsObject = {},
) {
  const fetchOptions = options ?? {};

  if (!fetchOptions.headers) {
    fetchOptions.headers = new Headers();
  }

  updateHeaders(fetchOptions.headers);
  if (request instanceof FormData) {
    removeContentTypeHeader(fetchOptions.headers);
  }

  const body = (request instanceof FormData) ? request : JSON.stringify(request);
  const maybeQueryString = getQueryParamsString(paramsObject);

  const requestOptions: RequestInit = {
    ...fetchOptions,
    method,
    body,
    redirect: "follow",
  };

  return { options: requestOptions, url: `${url}${maybeQueryString}` } as FetchArgs;
}

export function getQueryParamsString(paramsObject: ParamsObject = {}) {
	const queryString = Object.entries(paramsObject)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map(val => `${encodeURIComponent(key)}=${encodeURIComponent(
            val,
          )}`)
          .join('&');
      }
      // Handling non-array parameters
      return value !== undefined && value !== null 
        ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` 
        : '';
    })
    .filter(part => part !== '')
    .join("&");

	return queryString.length > 0 ? `?${queryString}` : '';
}

export function apiPost<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("POST", request, options, url, paramsObject));
}

export function apiGet<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("GET", undefined, options, url, paramsObject));
}

export function apiPut<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PUT", request, options, url, paramsObject));
}

export function apiDelete<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("DELETE", undefined, options, url, paramsObject));
}

export function apiPatch<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PATCH", request, options, url, paramsObject));
}
// INFRASTRUCTURE END

export type AcceptConnectionInputDto = {
	advisorId: string;
};

export type AcceptConnectionOutputDto = {
	advisorLogo?: string | null;
	activeColor?: string | null;
	is_main: boolean;
	id: string;
	advisorsPending: number;
};

export type Advisor = {
	phone: string;
	name: string;
	email: string;
	id: string;
	avatar: string;
	avatar_hash: string;
	is_main: number;
	conversation_id?: number | null;
};

export type AdvisorBaseDetail = {
	phone?: string | null;
	name?: string | null;
	email: string;
	id: string;
	avatar?: string | null;
	avatar_hash?: string | null;
	is_main?: number | null;
	conversation_id?: number | null;
};

export type AdvisorDetailOutputDto = {
	id: string;
	phone?: string | null;
	job?: string | null;
	description?: string | null;
	linkedin?: string | null;
	website?: string | null;
	address?: string | null;
	photo_avatar?: string | null;
	photo_company?: string | null;
	custom_color?: string | null;
	name?: string | null;
	email: string;
	avatar?: string | null;
	avatar_hash?: string | null;
	is_main?: number | null;
	conversation_id?: number | null;
	connection_status: string;
};

export type AssignedListOutputDto = {
	items: AdvisorBaseDetail[];
	advisorsPending: number;
	isNextPage: boolean;
};

export type DeleteInputDto = {
	id: string;
};

export type DetailInputDto = {
	id: string;
};

export type ListAllOutputDto = {
	items: AdvisorDetailOutputDto[];
	advisorsPending: number;
	isNextPage: boolean;
};

export type PendingListOutputDto = {
	items: Advisor[];
	advisorsPending: number;
	isNextPage: boolean;
};

export type RefuseConnectionInputDto = {
	advisorId: string;
};

export type RefuseConnectionOutputDto = {
	id: string;
	advisorsPending: number;
};

export type SetMainInputDto = {
	id: string;
};

export type SetMainOutputDto = {
	advisorLogo?: string | null;
	activeColor?: string | null;
};

export type LangOutputDto = {
	cs?: string | null;
	en?: string | null;
};

export type LanguageHashOutputDto = {
	language_hash: string;
};

export type LogErrorOutputDto = {
	logId: number;
};

export type SyncInputDto = {
	token?: string | null;
	title?: string | null;
	version?: number | null;
};

export type SynchronizationOutputDto = {
	activeColor?: string | null;
	advisorLogo?: string | null;
	hsp_company?: string | null;
	user_id?: string | null;
	avatar?: string | null;
	avatar_hash: string;
	name?: string | null;
	email: string;
	language_hash: string;
	chat_not_read: number;
	ntf_not_read: number;
	advisorsPending: number;
};

export type AccessToken = {
	id: number;
	token: string;
	token_verify: string;
	user_id: number;
};

export type AdvisorRegistrationInputDto = {
	token: string;
	email: string;
	password: string;
};

export type ForgottenPasswordInputDto = {
	email: string;
};

export type LoginInputDto = {
	email: string;
	password: string;
};

export type LoginOutputDto = {
	status: string;
	token: string;
	method: string;
};

export type PasswordResetInputDto = {
	token: string;
	password: string;
};

export type VerifyCodeInputDto = {
	twoFactorToken: string;
	verifyCode: string;
};

export type VerifyCodeOutputDto = {
	token: string;
	token_verify: string;
};

export type AccessItemsOutputDto = {
	items: AccessDto[];
};

export type MortgageRateOutputDto = {
	bank_id: number;
	ltv_from: number;
	ltv_to: number;
	amount_from: number;
	amount_to?: number | null;
	maturity_from: number;
	maturity_to: number;
	rate: number;
	mortgage_purpose_id: number;
};

export type RedirectActionOutputDto = {
	redirectUrl: string;
};

export type ChatAddFirstInputDto = {
	advisorIds: string[];
	content: string;
};

export type ChatAddFirstOutputDto = {
	item: ChatMessageDetailOutputDto;
};

export type ChatAddImageInputDto = {
	conversationId: number;
	content: string;
	attachment: unknown;
	attachmentTitle: string;
};

export type ChatAddImageOutputDto = {
	item: ChatMessageDetailOutputDto;
};

export type ChatAddInputDto = {
	conversationId: number;
	content: string;
};

export type ChatAddOutputDto = {
	item: ChatMessageDetailOutputDto;
};

export type ChatAttachmentDto = {
	id: number;
	chat_message_id: number;
	chat_conversation_id: number;
	type: string;
	mimeType: string;
	fileName: string;
	name?: string | null;
	created_at: string;
	thumbnail?: string | null;
	size: number;
};

export type ChatDetailInputDto = {
	id: number;
	page: number;
};

export type ChatDetailOutputDto = {
	conversationId: number;
	items: ChatMessageDetailOutputDto[];
	isNextPage: boolean;
};

export type ChatLeaveGroupInputDto = {
	conversationId: number;
};

export type ChatLeaveGroupOutputDto = {
	success: boolean;
};

export type ChatListItemDto = {
	id: number;
	title: string;
};

export type ChatListOutputDto = {
	items: ChatListItemDto[];
	chat_not_read_count: number;
	isNextPage: boolean;
};

export type ChatMessageDetailOutputDto = {
	id: number;
	chat_message_id: number;
	chat_conversation: number;
	user_id: number;
	content: string;
	from: number;
	created_at: string;
	is_read: number;
	is_mine: number;
	user_type: string;
	avatar_hash?: string | null;
	sender_type: string;
	from_name: string;
	from_id: string;
	is_group: number;
	attachments: ChatAttachmentDto;
};

export type ChatSetReadMessageInputDto = {
	conversationId: number;
	messageId: number;
};

export type ChatSetReadOutputDto = {
	not_read: number;
};

export type DocumentDetailDataDto = {
	type: string;
	document_type: string;
	id: string;
	title: string;
	filename: string;
	parents: string[];
	created_at: string;
	file_size: string;
	mime_type: string;
	title_editable: boolean;
};

export type DocumentDetailOutputDto = {
	items: DocumentItemWithParentDto[];
	isNextPage: boolean;
};

export type DocumentEditInputDto = {
	id: number;
	title: string;
	tags: string;
};

export type DocumentItemWithParentDto = {
	type: string;
	id: number;
	title: string;
	filename: string;
};

export type DocumentListAllOutputDto = {
	items: any[][];
	isNextPage: boolean;
};

export type DocumentListItemDto = {
	type: string;
	id: number;
	title: string;
	filename: string;
	parent: string;
};

export type DocumentListOutputDto = {
	items: DocumentListItemDto[];
	isNextPage: boolean;
};

export type FolderDetailDto = {
	id: string;
	type: string;
	title: string;
	document_count: number;
	title_editable: boolean;
};

export type DocumentEditItemDto = {
	id: string;
	type: string;
	title: string;
};

export type DocumentEditOutputDto = {
	item: DocumentEditItemDto;
};

export type DocumentTagEditInputDto = {
	id: string;
	title: string;
};

export type AddClientActionDto = {
	uid: string;
};

export type AddClientActionOutputDto = {
	uid: string;
};

export type AddClientMailFailedOutputDto = {
	status: string;
	errorCode: string;
	error: string;
};

export type AddUpdateAdvisorOutputDto = {
	uid: string;
};

export type BrowserNtfDataDto = {
	url: string;
	ntf_title: string;
	ntf_body: string;
	ntf_type: string;
	additional_data: unknown;
};

export type ClientAndAdvisorUidInputDto = {
	client_uid: string;
	advisor_uid: string;
};

export type ClientDocumentDto = {
	id: number;
	title: string;
	filename: string;
	created_at: string;
	size: number;
	tags: string[];
};

export type DocumentSynchronizeIdsDto = {
	mydock_id?: string | null;
	myplann_id?: string | null;
};

export type DocumentSynchronizeOutputDto = {
	status: string;
	ids: DocumentSynchronizeIdsDto[];
};

export type DocumentTagBulkInput = {
	documentIds: number[];
	tag: string;
	client_uid: string;
	advisor_uid: string;
};

export type EditGroupMessageOutputDto = {
	chat_conversation: string;
	chat_conversation_title: string;
};

export type GetAllDocumentTagsInput = {
	advisor_uid: string;
};

export type GetClientDocumentOutputDto = {
	items: ClientDocumentDto[];
	count: number;
};

export type GetClientDocumentTagsInput = {
	client_uid: string;
	advisor_uid: string;
};

export type GetClientDocumentsPreviewOutputDto = {
	items: any[];
};

export type GetClientLocalDocumentStatsOutputDto = {
	documentsCount: number;
	clientUid: string;
	clientName: string;
	mainAgentUid: string;
	newestDocumentCreatedAt: string;
	documentIds: string;
};

export type ImportApiAddMessageOutputOutputDto = ChatMessageDetailOutputDto;

export type ImportApiIsClientAssignedOutputDto = {
	is_connected: boolean;
	connection_status: string;
	connected_at: string;
	last_activity_at?: string | null;
	is_registered: boolean;
	conversation_id?: number | null;
	id: string;
	email: string;
	name: string;
	phone?: string | null;
	is_advisor_main: number;
	status: string;
};

export type ImportApiIsClientExistsOutputDto = {
	is_connected: boolean;
	exists: boolean;
};

export type IsConnectedOutputDto = {
	is_connected: boolean;
	status: string;
};

export type IsWritableOutputDto = {
	is_writable: boolean;
};

export type PortfolioListItemFilterData = {
	producent?: string | null;
	datum_podpisu?: string | null;
};

export type PortfolioSynchronizeIdsDto = {
	mydock_id?: string | null;
	myplann_id?: string | null;
};

export type PortfolioSynchronizeOutputDto = {
	ids: PortfolioSynchronizeIdsDto[];
};

export type ToMyDockDocumentDto = {
	id: number;
	title: string;
	filename: string;
	created_at: string;
	size: string;
	tags: string[];
};

export type NotificationAddInputDto = {
	type: "addDocument" | "editDocument" | "removeDocument" | "signRecord" | "addExpense" | "editExpense" | "removeExpense" | "addIncome" | "editIncome" | "removeIncome";
	object_id: number;
	changes: NotificationChangeData[];
};

export type NotificationChangeData = {
	attribute: string;
	originalValue?: string | null;
	newValue?: string | null;
};

export type NotificationIdInputDto = {
	notificationId: number;
};

export type NotificationItem = {
	id: number;
	created_at: string;
	type: string;
	data: unknown;
	seen_at: string;
	visited_at: string;
	title: string;
	subtitle: string;
};

export type NotificationListInputDto = {
	page: number;
};

export type NotificationListOutputDto = {
	items: NotificationItem[];
	ntf_not_read: number;
	isNextPage: boolean;
};

export type NotificationSetReadOutputDto = {
	ntf_not_read: number;
};

export type PortfolioDetailDocumentDto = {
	title: string;
	filename: string;
	type: string;
	id: number;
	myplann_id: number;
	mime: string;
};

export type PortfolioDetailOutputDto = {
	id: number;
	type: string;
	title?: string | null;
	icon?: string | null;
	icon_color?: string | null;
	icon_text?: string | null;
	left?: string | null;
	right?: string | null;
	detail: unknown;
	documents: PortfolioDetailDocumentDto[];
};

export type PortfolioListItemDto = {
	id: number;
	type: string;
	subtype?: string | null;
	title?: string | null;
	icon?: string | null;
	icon_color?: string | null;
	icon_text?: string | null;
	left?: string | null;
	right?: string | null;
	filter_data: PortfolioListItemFilterData;
};

export type PortfolioListOutputDto = {
	items: PortfolioListItemDto[];
	isNextPage: boolean;
};

export type Address = {
	address_id: number;
	street?: string | null;
	street_number?: string | null;
	city?: string | null;
	postcode?: string | null;
	country?: string | null;
};

export enum AddressType {
	Permanent = "Permanent",
	Contact = "Contact"
};

export type AddressUserTyped = Address;

export type BankAccount = {
	account_id?: number | null;
	account_name: string;
	account_number: string;
	iban: string;
	currency: string;
};

export type Expense = {
	expense_id?: number | null;
	expense_name?: string | null;
	expense_type?: "housing" | "traffic" | "saving" | "insurance" | "household" | "other" | "taxes" | null;
	required?: boolean | null;
	minimum_amount?: number | null;
	amount?: number | null;
	frequency?: Frequency | null;
	note?: string | null;
};

export type HouseholdExpenseDto = {
	celkem: FinancialPlanItemDto;
	jidlo: FinancialPlanItemDto;
	kapesne: FinancialPlanItemDto;
	kadernictví: FinancialPlanItemDto;
	obleceni: FinancialPlanItemDto;
	sport: FinancialPlanItemDto;
	kultura: FinancialPlanItemDto;
	restaurace: FinancialPlanItemDto;
	domaciMazlicci: FinancialPlanItemDto;
	predplatne: FinancialPlanItemDto;
	knihy: FinancialPlanItemDto;
	mobil: FinancialPlanItemDto;
	skolne: FinancialPlanItemDto;
	darky: FinancialPlanItemDto;
	dovolena: FinancialPlanItemDto;
};

export type HousingExpenseDto = {
	celkem: FinancialPlanItemDto;
	najemne: FinancialPlanItemDto;
	energie: FinancialPlanItemDto;
	poplatky: FinancialPlanItemDto;
	ostatni: FinancialPlanItemDto;
};

export type InsuranceExpenseDto = {
	celkem: FinancialPlanItemDto;
	zivotni: FinancialPlanItemDto;
	domacnost: FinancialPlanItemDto;
	odpovednost: FinancialPlanItemDto;
};

export type OtherExpenseDto = {
	celkem: FinancialPlanItemDto;
	charita: FinancialPlanItemDto;
	uklid: FinancialPlanItemDto;
	alimenty: FinancialPlanItemDto;
	chuva: FinancialPlanItemDto;
	jine: FinancialPlanItemDto;
	uvery: FinancialPlanItemDto;
	cigarety: FinancialPlanItemDto;
};

export type SavingExpenseDto = {
	celkem: FinancialPlanItemDto;
	stavebniSporeni: FinancialPlanItemDto;
	penzijniProdukty: FinancialPlanItemDto;
	investice: FinancialPlanItemDto;
};

export type TaxesExpenseDto = {
	celkem: FinancialPlanItemDto;
	socialni: FinancialPlanItemDto;
	danZPrijmu: FinancialPlanItemDto;
	danZNemovitosti: FinancialPlanItemDto;
};

export type TrafficExpenseDto = {
	celkem: FinancialPlanItemDto;
	leasing: FinancialPlanItemDto;
	dalnicniZnamky: FinancialPlanItemDto;
	povHav: FinancialPlanItemDto;
	pohonneHmoty: FinancialPlanItemDto;
	udrzba: FinancialPlanItemDto;
	jizdne: FinancialPlanItemDto;
};

export type ExpenseId = {
	expense_id?: number | null;
};

export enum ExpenseType {
	housing = "housing",
	traffic = "traffic",
	saving = "saving",
	insurance = "insurance",
	household = "household",
	other = "other",
	taxes = "taxes"
};

export type ExpenseTypeDictionary = {
	housing: HousingExpenseDto;
	traffic: TrafficExpenseDto;
	saving: SavingExpenseDto;
	insurance: InsuranceExpenseDto;
	household: HouseholdExpenseDto;
	other: OtherExpenseDto;
	taxes: TaxesExpenseDto;
};

export type FinancialPlanItemDto = {
	label: string;
	notice: string;
	labelEn: string;
	keyCz: string;
	keyEn: string;
};

export enum Frequency {
	Weekly = "Weekly",
	Monthly = "Monthly",
	Yearly = "Yearly"
};

export type Income = {
	income_id?: number | null;
	income_type?: "employee" | "osvc" | "pension" | null;
	company?: string | null;
	position?: string | null;
	amount?: number | null;
	frequency?: Frequency | null;
	note?: string | null;
};

export type IncomeId = {
	income_id?: number | null;
};

export type Paperwork = {
	id: number;
	type: "op" | "cp" | "rp" | "pb" | "lp" | "pp" | "zp" | "is" | "jp" | "stk" | "kp" | "rl" | "ll" | "ot";
	due_date: string;
};

export type UserAvatarOutputDto = {
	id: string;
	photo_avatar?: string | null;
	hash?: string | null;
};

export type UserEditInputDto = {
	name?: string | null;
	avatar: File;
};

export type UserEditOutputDto = {
	name: string;
	avatar?: string | null;
	avatar_hash?: string | null;
};

export type UserPersonalBaseData = {
	name?: string | null;
	surname?: string | null;
	birth_number?: string | null;
	birth_date?: string | null;
	birth_place?: string | null;
	marital_status?: string | null;
	health_insurance_company?: string | null;
};

export type UserPersonalData = {
	user_id?: number | null;
	name?: string | null;
	surname?: string | null;
	email?: string | null;
	phone_number?: string | null;
	birth_number?: string | null;
	birth_date?: string | null;
	birth_place?: string | null;
	marital_status?: string | null;
	health_insurance_company?: string | null;
	bank_accounts: BankAccount[];
	permanent_address?: Address | null;
	contact_address: Address[];
	paperwork: Paperwork[];
	income: Income[];
	expense: Expense[];
};

export type UserRemoveInputDto = {
	password: string;
};

export type ErrorContentOutputDto = {
	error: string;
};

export type ErrorContentWithCodeOutputDto = {
	error: string;
	error_code: string;
};

export type ResponseOk = {
	status: string;
};

export type IdEntityDto = {
	id: number;
};

export type IdInputDto = {
	id: number;
};

export type IdObjectResponseDto = {
	id: number;
	responseObject: unknown;
	previousObject: unknown;
};

export type IdResponseDto = {
	id: number;
};

export type IdStringInputDto = {
	id: string;
};

export type User = {
	id: number;
	uid?: string | null;
	email: string;
	phone?: string | null;
	name?: string | null;
	type: UserTypeEnum;
	photo_avatar?: string | null;
	language: string;
	deleted_at?: string | null;
	created_at: string;
};

export type AccessDto = {
	calculatorType: CalculatorTypeEnum;
	show: boolean;
	access: boolean;
};

export enum CalculatorTypeEnum {
	TravelInsurance = "TravelInsurance",
	CarMotoInsurance = "CarMotoInsurance",
	PropertyInsurance = "PropertyInsurance",
	Mortgage = "Mortgage",
	Refinancing = "Refinancing",
	AmericanMortgage = "AmericanMortgage",
	ConsumerLoan = "ConsumerLoan",
	ChildrenSavings = "ChildrenSavings",
	PensionAnnuity = "PensionAnnuity",
	GoalAchieve = "GoalAchieve",
	Bilance = "Bilance"
};

export enum UserTypeEnum {
	Client = "Client",
	Advisor = "Advisor",
	Assistant = "Assistant"
};

export type PostAdvisorAcceptConnectionFetchResponse = 
| FetchResponse<{statusCode: string;
	data: AcceptConnectionOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postAdvisorAcceptConnectionPath = () => `/advisor/accept-connection`;

export const postAdvisorAcceptConnection = (requestContract: AcceptConnectionInputDto, options?: FetchArgsOptions):
  Promise<PostAdvisorAcceptConnectionFetchResponse> => {
    const requestData = getApiRequestData<AcceptConnectionInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAdvisorAcceptConnectionPath()}`, requestData, options) as Promise<PostAdvisorAcceptConnectionFetchResponse>;
}

export type PostAdvisorListFetchResponse = 
| FetchResponse<{statusCode: string;
	data: AssignedListOutputDto;}, 200> 
| ErrorResponse;

export const postAdvisorListPath = () => `/advisor/list`;

export const postAdvisorList = (options?: FetchArgsOptions):
  Promise<PostAdvisorListFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdvisorListPath()}`, requestData, options) as Promise<PostAdvisorListFetchResponse>;
}

export type DeleteAdvisorDeleteFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const deleteAdvisorDeletePath = () => `/advisor/delete`;

export const deleteAdvisorDelete = (id: string, options?: FetchArgsOptions):
  Promise<DeleteAdvisorDeleteFetchResponse> => {
    const queryParams = {
      "id": id
    }
    return apiDelete(`${getApiUrl()}${deleteAdvisorDeletePath()}`, options, queryParams) as Promise<DeleteAdvisorDeleteFetchResponse>;
}

export type PostAdvisorDetailFetchResponse = 
| FetchResponse<{statusCode: string;
	data: AdvisorDetailOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postAdvisorDetailPath = () => `/advisor/detail`;

export const postAdvisorDetail = (requestContract: DetailInputDto, options?: FetchArgsOptions):
  Promise<PostAdvisorDetailFetchResponse> => {
    const requestData = getApiRequestData<DetailInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAdvisorDetailPath()}`, requestData, options) as Promise<PostAdvisorDetailFetchResponse>;
}

export type PostAdvisorListAllFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ListAllOutputDto;}, 200> 
| ErrorResponse;

export const postAdvisorListAllPath = () => `/advisor/list-all`;

export const postAdvisorListAll = (options?: FetchArgsOptions):
  Promise<PostAdvisorListAllFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdvisorListAllPath()}`, requestData, options) as Promise<PostAdvisorListAllFetchResponse>;
}

export type PostAdvisorPendingListFetchResponse = 
| FetchResponse<{statusCode: string;
	data: PendingListOutputDto;}, 200> 
| ErrorResponse;

export const postAdvisorPendingListPath = () => `/advisor/pending-list`;

export const postAdvisorPendingList = (options?: FetchArgsOptions):
  Promise<PostAdvisorPendingListFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAdvisorPendingListPath()}`, requestData, options) as Promise<PostAdvisorPendingListFetchResponse>;
}

export type PostAdvisorRefuseConnectionFetchResponse = 
| FetchResponse<{statusCode: string;
	data: RefuseConnectionOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postAdvisorRefuseConnectionPath = () => `/advisor/refuse-connection`;

export const postAdvisorRefuseConnection = (requestContract: RefuseConnectionInputDto, options?: FetchArgsOptions):
  Promise<PostAdvisorRefuseConnectionFetchResponse> => {
    const requestData = getApiRequestData<RefuseConnectionInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAdvisorRefuseConnectionPath()}`, requestData, options) as Promise<PostAdvisorRefuseConnectionFetchResponse>;
}

export type PostAdvisorSetMainFetchResponse = 
| FetchResponse<{statusCode: string;
	data: SetMainOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postAdvisorSetMainPath = () => `/advisor/set-main`;

export const postAdvisorSetMain = (requestContract: SetMainInputDto, options?: FetchArgsOptions):
  Promise<PostAdvisorSetMainFetchResponse> => {
    const requestData = getApiRequestData<SetMainInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAdvisorSetMainPath()}`, requestData, options) as Promise<PostAdvisorSetMainFetchResponse>;
}

export type PostAppLanguageCheckFetchResponse = 
| FetchResponse<{statusCode: string;
	data: LanguageHashOutputDto;}, 200> 
| ErrorResponse;

export const postAppLanguageCheckPath = () => `/app/language-check`;

export const postAppLanguageCheck = (options?: FetchArgsOptions):
  Promise<PostAppLanguageCheckFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAppLanguageCheckPath()}`, requestData, options) as Promise<PostAppLanguageCheckFetchResponse>;
}

export type PostAppLanguageSyncFetchResponse = 
| FetchResponse<{statusCode: string;
	data: LangOutputDto;}, 200> 
| ErrorResponse;

export const postAppLanguageSyncPath = () => `/app/language-sync`;

export const postAppLanguageSync = (options?: FetchArgsOptions):
  Promise<PostAppLanguageSyncFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAppLanguageSyncPath()}`, requestData, options) as Promise<PostAppLanguageSyncFetchResponse>;
}

export type PostAppLogErrorFetchResponse = 
| FetchResponse<{statusCode: string;
	data: LogErrorOutputDto;}, 200> 
| ErrorResponse;

export const postAppLogErrorPath = () => `/app/log-error`;

export const postAppLogError = (options?: FetchArgsOptions):
  Promise<PostAppLogErrorFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postAppLogErrorPath()}`, requestData, options) as Promise<PostAppLogErrorFetchResponse>;
}

export type PostAppSyncFetchResponse = 
| FetchResponse<{statusCode: string;
	data: SynchronizationOutputDto;}, 200> 
| ErrorResponse;

export const postAppSyncPath = () => `/app/sync`;

export const postAppSync = (requestContract: SyncInputDto, options?: FetchArgsOptions):
  Promise<PostAppSyncFetchResponse> => {
    const requestData = getApiRequestData<SyncInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAppSyncPath()}`, requestData, options) as Promise<PostAppSyncFetchResponse>;
}

export type PostAuthAdvisorRegistrationFetchResponse = 
| FetchResponse<{statusCode: string;
	data: AccessToken;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postAuthAdvisorRegistrationPath = () => `/auth/advisor-registration`;

export const postAuthAdvisorRegistration = (requestContract: AdvisorRegistrationInputDto, options?: FetchArgsOptions):
  Promise<PostAuthAdvisorRegistrationFetchResponse> => {
    const requestData = getApiRequestData<AdvisorRegistrationInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthAdvisorRegistrationPath()}`, requestData, options) as Promise<PostAuthAdvisorRegistrationFetchResponse>;
}

export type PostAuthForgottenPasswordFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postAuthForgottenPasswordPath = () => `/auth/forgotten-password`;

export const postAuthForgottenPassword = (requestContract: ForgottenPasswordInputDto, options?: FetchArgsOptions):
  Promise<PostAuthForgottenPasswordFetchResponse> => {
    const requestData = getApiRequestData<ForgottenPasswordInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthForgottenPasswordPath()}`, requestData, options) as Promise<PostAuthForgottenPasswordFetchResponse>;
}

export type PostAuthLoginFetchResponse = 
| FetchResponse<{statusCode: string;
	data: LoginOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 401> 
| ErrorResponse;

export const postAuthLoginPath = () => `/auth/login`;

export const postAuthLogin = (requestContract: LoginInputDto, options?: FetchArgsOptions):
  Promise<PostAuthLoginFetchResponse> => {
    const requestData = getApiRequestData<LoginInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthLoginPath()}`, requestData, options) as Promise<PostAuthLoginFetchResponse>;
}

export type PostAuthPasswordResetFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 401> 
| ErrorResponse;

export const postAuthPasswordResetPath = () => `/auth/password-reset`;

export const postAuthPasswordReset = (requestContract: PasswordResetInputDto, options?: FetchArgsOptions):
  Promise<PostAuthPasswordResetFetchResponse> => {
    const requestData = getApiRequestData<PasswordResetInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthPasswordResetPath()}`, requestData, options) as Promise<PostAuthPasswordResetFetchResponse>;
}

export type PostAuthVerifyCodeFetchResponse = 
| FetchResponse<{statusCode: string;
	data: VerifyCodeOutputDto;}, 200> 
| FetchResponse<void, 401> 
| ErrorResponse;

export const postAuthVerifyCodePath = () => `/auth/verify-code`;

export const postAuthVerifyCode = (requestContract: VerifyCodeInputDto, options?: FetchArgsOptions):
  Promise<PostAuthVerifyCodeFetchResponse> => {
    const requestData = getApiRequestData<VerifyCodeInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthVerifyCodePath()}`, requestData, options) as Promise<PostAuthVerifyCodeFetchResponse>;
}

export type GetCalculatorAccessFetchResponse = 
| FetchResponse<{statusCode: string;
	data: AccessItemsOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const getCalculatorAccessPath = () => `/calculator/access`;

export const getCalculatorAccess = (options?: FetchArgsOptions):
  Promise<GetCalculatorAccessFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCalculatorAccessPath()}`, options, {}) as Promise<GetCalculatorAccessFetchResponse>;
}

export type PostCalculatorCalculatorTypeLeadFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const postCalculatorCalculatorTypeLeadPath = (calculatorType: string) => `/calculator/${calculatorType}/lead`;

export const postCalculatorCalculatorTypeLead = (calculatorType: string, options?: FetchArgsOptions):
  Promise<PostCalculatorCalculatorTypeLeadFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postCalculatorCalculatorTypeLeadPath(calculatorType)}`, requestData, options) as Promise<PostCalculatorCalculatorTypeLeadFetchResponse>;
}

export type GetCalculatorMortgageRatesFetchResponse = 
| FetchResponse<{statusCode: string;
	data: MortgageRateOutputDto[];}, 200> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const getCalculatorMortgageRatesPath = () => `/calculator/mortgage-rates`;

export const getCalculatorMortgageRates = (options?: FetchArgsOptions):
  Promise<GetCalculatorMortgageRatesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCalculatorMortgageRatesPath()}`, options, {}) as Promise<GetCalculatorMortgageRatesFetchResponse>;
}

export type GetCalculatorCalculatorTypeRedirectFetchResponse = 
| FetchResponse<{statusCode: string;
	data: RedirectActionOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const getCalculatorCalculatorTypeRedirectPath = (calculatorType: string) => `/calculator/${calculatorType}/redirect`;

export const getCalculatorCalculatorTypeRedirect = (calculatorType: string, options?: FetchArgsOptions):
  Promise<GetCalculatorCalculatorTypeRedirectFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCalculatorCalculatorTypeRedirectPath(calculatorType)}`, options, {}) as Promise<GetCalculatorCalculatorTypeRedirectFetchResponse>;
}

export type GetCalculatorRefinancingRatesFetchResponse = 
| FetchResponse<MortgageRateOutputDto[], 200> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const getCalculatorRefinancingRatesPath = () => `/calculator/refinancing-rates`;

export const getCalculatorRefinancingRates = (options?: FetchArgsOptions):
  Promise<GetCalculatorRefinancingRatesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCalculatorRefinancingRatesPath()}`, options, {}) as Promise<GetCalculatorRefinancingRatesFetchResponse>;
}

export type PostChatAddFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ChatAddOutputDto;}, 200> 
| ErrorResponse;

export const postChatAddPath = () => `/chat/add`;

export const postChatAdd = (requestContract: ChatAddInputDto, options?: FetchArgsOptions):
  Promise<PostChatAddFetchResponse> => {
    const requestData = getApiRequestData<ChatAddInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postChatAddPath()}`, requestData, options) as Promise<PostChatAddFetchResponse>;
}

export type PostChatAddFirstFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ChatAddFirstOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| FetchResponse<void, 500> 
| ErrorResponse;

export const postChatAddFirstPath = () => `/chat/add-first`;

export const postChatAddFirst = (requestContract: ChatAddFirstInputDto, options?: FetchArgsOptions):
  Promise<PostChatAddFirstFetchResponse> => {
    const requestData = getApiRequestData<ChatAddFirstInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postChatAddFirstPath()}`, requestData, options) as Promise<PostChatAddFirstFetchResponse>;
}

export type PostChatAddImageFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ChatAddImageOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postChatAddImagePath = () => `/chat/add-image`;

export const postChatAddImage = (requestContract: ChatAddImageInputDto, options?: FetchArgsOptions):
  Promise<PostChatAddImageFetchResponse> => {
    const requestData = getApiRequestData<ChatAddImageInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postChatAddImagePath()}`, requestData, options) as Promise<PostChatAddImageFetchResponse>;
}

export type PostChatDetailListFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ChatDetailOutputDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postChatDetailListPath = () => `/chat/detail-list`;

export const postChatDetailList = (requestContract: ChatDetailInputDto, options?: FetchArgsOptions):
  Promise<PostChatDetailListFetchResponse> => {
    const requestData = getApiRequestData<ChatDetailInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postChatDetailListPath()}`, requestData, options) as Promise<PostChatDetailListFetchResponse>;
}

export type PostChatLeaveGroupFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ChatLeaveGroupOutputDto;}, 200> 
| ErrorResponse;

export const postChatLeaveGroupPath = () => `/chat/leave-group`;

export const postChatLeaveGroup = (requestContract: ChatLeaveGroupInputDto, options?: FetchArgsOptions):
  Promise<PostChatLeaveGroupFetchResponse> => {
    const requestData = getApiRequestData<ChatLeaveGroupInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postChatLeaveGroupPath()}`, requestData, options) as Promise<PostChatLeaveGroupFetchResponse>;
}

export type PostChatListFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ChatListOutputDto;}, 200> 
| ErrorResponse;

export const postChatListPath = () => `/chat/list`;

export const postChatList = (options?: FetchArgsOptions):
  Promise<PostChatListFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postChatListPath()}`, requestData, options) as Promise<PostChatListFetchResponse>;
}

export type PostChatSetReadMessageFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ChatSetReadOutputDto;}, 200> 
| ErrorResponse;

export const postChatSetReadMessagePath = () => `/chat/set-read-message`;

export const postChatSetReadMessage = (requestContract: ChatSetReadMessageInputDto, options?: FetchArgsOptions):
  Promise<PostChatSetReadMessageFetchResponse> => {
    const requestData = getApiRequestData<ChatSetReadMessageInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postChatSetReadMessagePath()}`, requestData, options) as Promise<PostChatSetReadMessageFetchResponse>;
}

export type GetChatViewImageIdFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const getChatViewImageIdPath = (id: number) => `/chat/view-image/${id}`;

export const getChatViewImageId = (id: number, options?: FetchArgsOptions):
  Promise<GetChatViewImageIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getChatViewImageIdPath(id)}`, options, {}) as Promise<GetChatViewImageIdFetchResponse>;
}

export type PostDocumentAddFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postDocumentAddPath = () => `/document/add`;

export const postDocumentAdd = (options?: FetchArgsOptions):
  Promise<PostDocumentAddFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postDocumentAddPath()}`, requestData, options) as Promise<PostDocumentAddFetchResponse>;
}

export type DeleteDocumentDeleteFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const deleteDocumentDeletePath = () => `/document/delete`;

export const deleteDocumentDelete = (id: number, options?: FetchArgsOptions):
  Promise<DeleteDocumentDeleteFetchResponse> => {
    const queryParams = {
      "id": id
    }
    return apiDelete(`${getApiUrl()}${deleteDocumentDeletePath()}`, options, queryParams) as Promise<DeleteDocumentDeleteFetchResponse>;
}

export type PostDocumentDetailFetchResponse = 
| FetchResponse<{statusCode: string;
	data: DocumentDetailOutputDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postDocumentDetailPath = () => `/document/detail`;

export const postDocumentDetail = (requestContract: IdStringInputDto, options?: FetchArgsOptions):
  Promise<PostDocumentDetailFetchResponse> => {
    const requestData = getApiRequestData<IdStringInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postDocumentDetailPath()}`, requestData, options) as Promise<PostDocumentDetailFetchResponse>;
}

export type GetDocumentDetailIdDownloadFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const getDocumentDetailIdDownloadPath = (id: number) => `/document/detail/${id}/download`;

export const getDocumentDetailIdDownload = (id: number, options?: FetchArgsOptions):
  Promise<GetDocumentDetailIdDownloadFetchResponse> => {
    return apiGet(`${getApiUrl()}${getDocumentDetailIdDownloadPath(id)}`, options, {}) as Promise<GetDocumentDetailIdDownloadFetchResponse>;
}

export type PostDocumentEditFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postDocumentEditPath = () => `/document/edit`;

export const postDocumentEdit = (requestContract: DocumentEditInputDto, options?: FetchArgsOptions):
  Promise<PostDocumentEditFetchResponse> => {
    const requestData = getApiRequestData<DocumentEditInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postDocumentEditPath()}`, requestData, options) as Promise<PostDocumentEditFetchResponse>;
}

export type PostDocumentListFetchResponse = 
| FetchResponse<{statusCode: string;
	data: DocumentListOutputDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postDocumentListPath = () => `/document/list`;

export const postDocumentList = (options?: FetchArgsOptions):
  Promise<PostDocumentListFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postDocumentListPath()}`, requestData, options) as Promise<PostDocumentListFetchResponse>;
}

export type PostDocumentListAllFetchResponse = 
| FetchResponse<{statusCode: string;
	data: DocumentListAllOutputDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postDocumentListAllPath = () => `/document/list-all`;

export const postDocumentListAll = (options?: FetchArgsOptions):
  Promise<PostDocumentListAllFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postDocumentListAllPath()}`, requestData, options) as Promise<PostDocumentListAllFetchResponse>;
}

export type DeleteDocumentDeleteTagFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const deleteDocumentDeleteTagPath = () => `/document/delete-tag`;

export const deleteDocumentDeleteTag = (id: string, options?: FetchArgsOptions):
  Promise<DeleteDocumentDeleteTagFetchResponse> => {
    const queryParams = {
      "id": id
    }
    return apiDelete(`${getApiUrl()}${deleteDocumentDeleteTagPath()}`, options, queryParams) as Promise<DeleteDocumentDeleteTagFetchResponse>;
}

export type PostDocumentEditTagFetchResponse = 
| FetchResponse<{statusCode: string;
	data: DocumentEditOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postDocumentEditTagPath = () => `/document/edit-tag`;

export const postDocumentEditTag = (requestContract: DocumentTagEditInputDto, options?: FetchArgsOptions):
  Promise<PostDocumentEditTagFetchResponse> => {
    const requestData = getApiRequestData<DocumentTagEditInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postDocumentEditTagPath()}`, requestData, options) as Promise<PostDocumentEditTagFetchResponse>;
}

export type PostImportApiAddClientFetchResponse = 
| FetchResponse<AddClientActionOutputDto, 200> 
| FetchResponse<AddClientMailFailedOutputDto, 400> 
| ErrorResponse;

export const postImportApiAddClientPath = () => `/import-api/add-client`;

export const postImportApiAddClient = (options?: FetchArgsOptions):
  Promise<PostImportApiAddClientFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiAddClientPath()}`, requestData, options) as Promise<PostImportApiAddClientFetchResponse>;
}

export type PostImportApiAddMessageFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ImportApiAddMessageOutputOutputDto;}, 200> 
| ErrorResponse;

export const postImportApiAddMessagePath = () => `/import-api/add-message`;

export const postImportApiAddMessage = (options?: FetchArgsOptions):
  Promise<PostImportApiAddMessageFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiAddMessagePath()}`, requestData, options) as Promise<PostImportApiAddMessageFetchResponse>;
}

export type PostImportApiAddAdvisorFetchResponse = 
| FetchResponse<{statusCode: string;
	data: AddUpdateAdvisorOutputDto;}, 200> 
| ErrorResponse;

export const postImportApiAddAdvisorPath = () => `/import-api/add-advisor`;

export const postImportApiAddAdvisor = (options?: FetchArgsOptions):
  Promise<PostImportApiAddAdvisorFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiAddAdvisorPath()}`, requestData, options) as Promise<PostImportApiAddAdvisorFetchResponse>;
}

export type PostImportApiClientsCopyFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| ErrorResponse;

export const postImportApiClientsCopyPath = () => `/import-api/clients-copy`;

export const postImportApiClientsCopy = (options?: FetchArgsOptions):
  Promise<PostImportApiClientsCopyFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiClientsCopyPath()}`, requestData, options) as Promise<PostImportApiClientsCopyFetchResponse>;
}

export type PostImportApiClientsUnconnectFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| ErrorResponse;

export const postImportApiClientsUnconnectPath = () => `/import-api/clients-unconnect`;

export const postImportApiClientsUnconnect = (options?: FetchArgsOptions):
  Promise<PostImportApiClientsUnconnectFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiClientsUnconnectPath()}`, requestData, options) as Promise<PostImportApiClientsUnconnectFetchResponse>;
}

export type PostImportApiConnectClientAdvisorFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<any, 400> 
| ErrorResponse;

export const postImportApiConnectClientAdvisorPath = () => `/import-api/connect-client-advisor`;

export const postImportApiConnectClientAdvisor = (options?: FetchArgsOptions):
  Promise<PostImportApiConnectClientAdvisorFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiConnectClientAdvisorPath()}`, requestData, options) as Promise<PostImportApiConnectClientAdvisorFetchResponse>;
}

export type PostImportApiCreateGroupFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ChatMessageDetailOutputDto;}, 200> 
| ErrorResponse;

export const postImportApiCreateGroupPath = () => `/import-api/create-group`;

export const postImportApiCreateGroup = (options?: FetchArgsOptions):
  Promise<PostImportApiCreateGroupFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiCreateGroupPath()}`, requestData, options) as Promise<PostImportApiCreateGroupFetchResponse>;
}

export type PostImportApiDocumentSynchronizeFetchResponse = 
| FetchResponse<{statusCode: string;
	data: DocumentSynchronizeOutputDto;}, 200> 
| ErrorResponse;

export const postImportApiDocumentSynchronizePath = () => `/import-api/document-synchronize   `;

export const postImportApiDocumentSynchronize = (options?: FetchArgsOptions):
  Promise<PostImportApiDocumentSynchronizeFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiDocumentSynchronizePath()}`, requestData, options) as Promise<PostImportApiDocumentSynchronizeFetchResponse>;
}

export type PostImportApiDocumentSynchronizeBulkFetchResponse = 
| FetchResponse<{statusCode: string;
	data: DocumentSynchronizeOutputDto;}, 200> 
| ErrorResponse;

export const postImportApiDocumentSynchronizeBulkPath = () => `/import-api/document-synchronize-bulk`;

export const postImportApiDocumentSynchronizeBulk = (options?: FetchArgsOptions):
  Promise<PostImportApiDocumentSynchronizeBulkFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiDocumentSynchronizeBulkPath()}`, requestData, options) as Promise<PostImportApiDocumentSynchronizeBulkFetchResponse>;
}

export type PostImportApiEditGroupFetchResponse = 
| FetchResponse<{statusCode: string;
	data: EditGroupMessageOutputDto;}, 200> 
| ErrorResponse;

export const postImportApiEditGroupPath = () => `/import-api/edit-group`;

export const postImportApiEditGroup = (options?: FetchArgsOptions):
  Promise<PostImportApiEditGroupFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiEditGroupPath()}`, requestData, options) as Promise<PostImportApiEditGroupFetchResponse>;
}

export type PostImportApiGetAdvisorByEmailFetchResponse = 
| FetchResponse<User, 200> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postImportApiGetAdvisorByEmailPath = () => `/import-api/get-advisor-by-email`;

export const postImportApiGetAdvisorByEmail = (options?: FetchArgsOptions):
  Promise<PostImportApiGetAdvisorByEmailFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiGetAdvisorByEmailPath()}`, requestData, options) as Promise<PostImportApiGetAdvisorByEmailFetchResponse>;
}

export type PostImportApiGetAdvisorByUidFetchResponse = 
| FetchResponse<User, 200> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postImportApiGetAdvisorByUidPath = () => `/import-api/get-advisor-by-uid`;

export const postImportApiGetAdvisorByUid = (options?: FetchArgsOptions):
  Promise<PostImportApiGetAdvisorByUidFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiGetAdvisorByUidPath()}`, requestData, options) as Promise<PostImportApiGetAdvisorByUidFetchResponse>;
}

export type PostImportApiGetAllDocumentTagsFetchResponse = 
| FetchResponse<string[], 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postImportApiGetAllDocumentTagsPath = () => `/import-api/get-all-document-tags`;

export const postImportApiGetAllDocumentTags = (requestContract: GetAllDocumentTagsInput, options?: FetchArgsOptions):
  Promise<PostImportApiGetAllDocumentTagsFetchResponse> => {
    const requestData = getApiRequestData<GetAllDocumentTagsInput>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportApiGetAllDocumentTagsPath()}`, requestData, options) as Promise<PostImportApiGetAllDocumentTagsFetchResponse>;
}

export type PostImportApiGetClientDocumentFetchResponse = 
| FetchResponse<{statusCode: string;
	data: GetClientDocumentOutputDto;}, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiGetClientDocumentPath = () => `/import-api/get-client-document`;

export const postImportApiGetClientDocument = (options?: FetchArgsOptions):
  Promise<PostImportApiGetClientDocumentFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiGetClientDocumentPath()}`, requestData, options) as Promise<PostImportApiGetClientDocumentFetchResponse>;
}

export type PostImportApiGetClientDocumentContentFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiGetClientDocumentContentPath = () => `/import-api/get-client-document-content`;

export const postImportApiGetClientDocumentContent = (options?: FetchArgsOptions):
  Promise<PostImportApiGetClientDocumentContentFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiGetClientDocumentContentPath()}`, requestData, options) as Promise<PostImportApiGetClientDocumentContentFetchResponse>;
}

export type PostImportApiGetClientDocumentTagsFetchResponse = 
| FetchResponse<string[], 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postImportApiGetClientDocumentTagsPath = () => `/import-api/get-client-document-tags`;

export const postImportApiGetClientDocumentTags = (requestContract: GetClientDocumentTagsInput, options?: FetchArgsOptions):
  Promise<PostImportApiGetClientDocumentTagsFetchResponse> => {
    const requestData = getApiRequestData<GetClientDocumentTagsInput>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportApiGetClientDocumentTagsPath()}`, requestData, options) as Promise<PostImportApiGetClientDocumentTagsFetchResponse>;
}

export type PostImportApiGetClientDocumentsFetchResponse = 
| FetchResponse<ToMyDockDocumentDto[], 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiGetClientDocumentsPath = () => `/import-api/get-client-documents`;

export const postImportApiGetClientDocuments = (options?: FetchArgsOptions):
  Promise<PostImportApiGetClientDocumentsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiGetClientDocumentsPath()}`, requestData, options) as Promise<PostImportApiGetClientDocumentsFetchResponse>;
}

export type PostImportApiGetClientDocumentsPreviewFetchResponse = 
| FetchResponse<{statusCode: string;
	data: GetClientDocumentsPreviewOutputDto;}, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiGetClientDocumentsPreviewPath = () => `/import-api/get-client-documents-preview`;

export const postImportApiGetClientDocumentsPreview = (options?: FetchArgsOptions):
  Promise<PostImportApiGetClientDocumentsPreviewFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiGetClientDocumentsPreviewPath()}`, requestData, options) as Promise<PostImportApiGetClientDocumentsPreviewFetchResponse>;
}

export type PostImportApiIsClientExistsByUidFetchResponse = 
| FetchResponse<any, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiIsClientExistsByUidPath = () => `/import-api/is-client-exists-by-uid`;

export const postImportApiIsClientExistsByUid = (requestContract: ClientAndAdvisorUidInputDto, options?: FetchArgsOptions):
  Promise<PostImportApiIsClientExistsByUidFetchResponse> => {
    const requestData = getApiRequestData<ClientAndAdvisorUidInputDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postImportApiIsClientExistsByUidPath()}`, requestData, options) as Promise<PostImportApiIsClientExistsByUidFetchResponse>;
}

export type PostImportApiGetClientLocalDocumentStatsFetchResponse = 
| FetchResponse<{statusCode: string;
	data: GetClientLocalDocumentStatsOutputDto[];}, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiGetClientLocalDocumentStatsPath = () => `/import-api/get-client-local-document-stats`;

export const postImportApiGetClientLocalDocumentStats = (options?: FetchArgsOptions):
  Promise<PostImportApiGetClientLocalDocumentStatsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiGetClientLocalDocumentStatsPath()}`, requestData, options) as Promise<PostImportApiGetClientLocalDocumentStatsFetchResponse>;
}

export type PostImportApiIsClientAssignedFetchResponse = 
| FetchResponse<any, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiIsClientAssignedPath = () => `/import-api/is-client-assigned`;

export const postImportApiIsClientAssigned = (requestContract: ClientAndAdvisorUidInputDto, options?: FetchArgsOptions):
  Promise<PostImportApiIsClientAssignedFetchResponse> => {
    const requestData = getApiRequestData<ClientAndAdvisorUidInputDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postImportApiIsClientAssignedPath()}`, requestData, options) as Promise<PostImportApiIsClientAssignedFetchResponse>;
}

export type PostImportApiIsConversationWritableFetchResponse = 
| FetchResponse<{statusCode: string;
	data: IsWritableOutputDto;}, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiIsConversationWritablePath = () => `/import-api/is-conversation-writable`;

export const postImportApiIsConversationWritable = (options?: FetchArgsOptions):
  Promise<PostImportApiIsConversationWritableFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiIsConversationWritablePath()}`, requestData, options) as Promise<PostImportApiIsConversationWritableFetchResponse>;
}

export type PostImportApiMultipleAdvisorUpdateFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| ErrorResponse;

export const postImportApiMultipleAdvisorUpdatePath = () => `/import-api/multiple-advisor-update`;

export const postImportApiMultipleAdvisorUpdate = (options?: FetchArgsOptions):
  Promise<PostImportApiMultipleAdvisorUpdateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiMultipleAdvisorUpdatePath()}`, requestData, options) as Promise<PostImportApiMultipleAdvisorUpdateFetchResponse>;
}

export type PostImportApiPortalStatsFetchResponse = 
| FetchResponse<object, 200> 
| ErrorResponse;

export const postImportApiPortalStatsPath = () => `/import-api/portal-stats`;

export const postImportApiPortalStats = (options?: FetchArgsOptions):
  Promise<PostImportApiPortalStatsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postImportApiPortalStatsPath()}`, requestData, options) as Promise<PostImportApiPortalStatsFetchResponse>;
}

export type PostImportApiPortfolioSynchronizeFetchResponse = 
| FetchResponse<{statusCode: string;
	data: PortfolioSynchronizeOutputDto;}, 200> 
| ErrorResponse;

export const postImportApiPortfolioSynchronizePath = () => `/import-api/portfolio-synchronize`;

export const postImportApiPortfolioSynchronize = (options?: FetchArgsOptions):
  Promise<PostImportApiPortfolioSynchronizeFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiPortfolioSynchronizePath()}`, requestData, options) as Promise<PostImportApiPortfolioSynchronizeFetchResponse>;
}

export type PostImportApiPortfolioUpdateFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| ErrorResponse;

export const postImportApiPortfolioUpdatePath = () => `/import-api/portfolio-update`;

export const postImportApiPortfolioUpdate = (options?: FetchArgsOptions):
  Promise<PostImportApiPortfolioUpdateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiPortfolioUpdatePath()}`, requestData, options) as Promise<PostImportApiPortfolioUpdateFetchResponse>;
}

export type PostImportApiBrowserNtfFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiBrowserNtfPath = () => `/import-api/browser-ntf`;

export const postImportApiBrowserNtf = (options?: FetchArgsOptions):
  Promise<PostImportApiBrowserNtfFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiBrowserNtfPath()}`, requestData, options) as Promise<PostImportApiBrowserNtfFetchResponse>;
}

export type PostImportApiRemoveAdvisorFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| ErrorResponse;

export const postImportApiRemoveAdvisorPath = () => `/import-api/remove-advisor`;

export const postImportApiRemoveAdvisor = (options?: FetchArgsOptions):
  Promise<PostImportApiRemoveAdvisorFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiRemoveAdvisorPath()}`, requestData, options) as Promise<PostImportApiRemoveAdvisorFetchResponse>;
}

export type PostImportApiRemoveDocumentsTagBulkFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postImportApiRemoveDocumentsTagBulkPath = () => `/import-api/remove-documents-tag-bulk`;

export const postImportApiRemoveDocumentsTagBulk = (requestContract: DocumentTagBulkInput, options?: FetchArgsOptions):
  Promise<PostImportApiRemoveDocumentsTagBulkFetchResponse> => {
    const requestData = getApiRequestData<DocumentTagBulkInput>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportApiRemoveDocumentsTagBulkPath()}`, requestData, options) as Promise<PostImportApiRemoveDocumentsTagBulkFetchResponse>;
}

export type PostImportApiRemoveMyplannFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiRemoveMyplannPath = () => `/import-api/remove-myplann`;

export const postImportApiRemoveMyplann = (options?: FetchArgsOptions):
  Promise<PostImportApiRemoveMyplannFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiRemoveMyplannPath()}`, requestData, options) as Promise<PostImportApiRemoveMyplannFetchResponse>;
}

export type PostImportApiSaveDocumentsTagBulkFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postImportApiSaveDocumentsTagBulkPath = () => `/import-api/save-documents-tag-bulk`;

export const postImportApiSaveDocumentsTagBulk = (requestContract: DocumentTagBulkInput, options?: FetchArgsOptions):
  Promise<PostImportApiSaveDocumentsTagBulkFetchResponse> => {
    const requestData = getApiRequestData<DocumentTagBulkInput>(requestContract, false);

    return apiPost(`${getApiUrl()}${postImportApiSaveDocumentsTagBulkPath()}`, requestData, options) as Promise<PostImportApiSaveDocumentsTagBulkFetchResponse>;
}

export type PostImportApiUpdateAuthorizedEmailFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<{error: boolean;}, 400> 
| ErrorResponse;

export const postImportApiUpdateAuthorizedEmailPath = () => `/import-api/update-authorized-email`;

export const postImportApiUpdateAuthorizedEmail = (options?: FetchArgsOptions):
  Promise<PostImportApiUpdateAuthorizedEmailFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postImportApiUpdateAuthorizedEmailPath()}`, requestData, options) as Promise<PostImportApiUpdateAuthorizedEmailFetchResponse>;
}

export type PostNotificationAddFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postNotificationAddPath = () => `/notification/add`;

export const postNotificationAdd = (requestContract: NotificationAddInputDto, options?: FetchArgsOptions):
  Promise<PostNotificationAddFetchResponse> => {
    const requestData = getApiRequestData<NotificationAddInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postNotificationAddPath()}`, requestData, options) as Promise<PostNotificationAddFetchResponse>;
}

export type PostNotificationListFetchResponse = 
| FetchResponse<{statusCode: string;
	data: NotificationListOutputDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postNotificationListPath = () => `/notification/list`;

export const postNotificationList = (requestContract: NotificationListInputDto, options?: FetchArgsOptions):
  Promise<PostNotificationListFetchResponse> => {
    const requestData = getApiRequestData<NotificationListInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postNotificationListPath()}`, requestData, options) as Promise<PostNotificationListFetchResponse>;
}

export type PostNotificationSetReadFetchResponse = 
| FetchResponse<{statusCode: string;
	data: NotificationSetReadOutputDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postNotificationSetReadPath = () => `/notification/set-read`;

export const postNotificationSetRead = (requestContract: NotificationIdInputDto, options?: FetchArgsOptions):
  Promise<PostNotificationSetReadFetchResponse> => {
    const requestData = getApiRequestData<NotificationIdInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postNotificationSetReadPath()}`, requestData, options) as Promise<PostNotificationSetReadFetchResponse>;
}

export type PostNotificationSetVisitedFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postNotificationSetVisitedPath = () => `/notification/set-visited`;

export const postNotificationSetVisited = (requestContract: NotificationIdInputDto, options?: FetchArgsOptions):
  Promise<PostNotificationSetVisitedFetchResponse> => {
    const requestData = getApiRequestData<NotificationIdInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postNotificationSetVisitedPath()}`, requestData, options) as Promise<PostNotificationSetVisitedFetchResponse>;
}

export type PostPortfolioDetailFetchResponse = 
| FetchResponse<{statusCode: string;
	data: PortfolioDetailOutputDto;}, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const postPortfolioDetailPath = () => `/portfolio/detail`;

export const postPortfolioDetail = (requestContract: IdEntityDto, options?: FetchArgsOptions):
  Promise<PostPortfolioDetailFetchResponse> => {
    const requestData = getApiRequestData<IdEntityDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPortfolioDetailPath()}`, requestData, options) as Promise<PostPortfolioDetailFetchResponse>;
}

export type GetPortfolioDetailPortfolioIdDownloadDocumentTypeIdFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 400> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const getPortfolioDetailPortfolioIdDownloadDocumentTypeIdPath = (type: string, id: number, portfolio_id: number) => `/portfolio/detail/${portfolio_id}/download-document/${type}/${id}`;

export const getPortfolioDetailPortfolioIdDownloadDocumentTypeId = (type: string, id: number, portfolio_id: number, options?: FetchArgsOptions):
  Promise<GetPortfolioDetailPortfolioIdDownloadDocumentTypeIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPortfolioDetailPortfolioIdDownloadDocumentTypeIdPath(type, id, portfolio_id)}`, options, {}) as Promise<GetPortfolioDetailPortfolioIdDownloadDocumentTypeIdFetchResponse>;
}

export type PostPortfolioListFetchResponse = 
| FetchResponse<{statusCode: string;
	data: PortfolioListOutputDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postPortfolioListPath = () => `/portfolio/list`;

export const postPortfolioList = (options?: FetchArgsOptions):
  Promise<PostPortfolioListFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postPortfolioListPath()}`, requestData, options) as Promise<PostPortfolioListFetchResponse>;
}

export type PostUserAvatarFetchResponse = 
| FetchResponse<{statusCode: string;
	data: UserAvatarOutputDto;}, 200> 
| ErrorResponse;

export const postUserAvatarPath = () => `/user/avatar`;

export const postUserAvatar = (requestContract: IdStringInputDto, options?: FetchArgsOptions):
  Promise<PostUserAvatarFetchResponse> => {
    const requestData = getApiRequestData<IdStringInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserAvatarPath()}`, requestData, options) as Promise<PostUserAvatarFetchResponse>;
}

export type PostUserDeleteExpenseFetchResponse = 
| FetchResponse<{statusCode: string;
	data: IdEntityDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postUserDeleteExpensePath = () => `/user/delete-expense`;

export const postUserDeleteExpense = (requestContract: ExpenseId, options?: FetchArgsOptions):
  Promise<PostUserDeleteExpenseFetchResponse> => {
    const requestData = getApiRequestData<ExpenseId>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserDeleteExpensePath()}`, requestData, options) as Promise<PostUserDeleteExpenseFetchResponse>;
}

export type PostUserDeleteIncomeFetchResponse = 
| FetchResponse<{statusCode: string;
	data: IdEntityDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postUserDeleteIncomePath = () => `/user/delete-income`;

export const postUserDeleteIncome = (requestContract: IncomeId, options?: FetchArgsOptions):
  Promise<PostUserDeleteIncomeFetchResponse> => {
    const requestData = getApiRequestData<IncomeId>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserDeleteIncomePath()}`, requestData, options) as Promise<PostUserDeleteIncomeFetchResponse>;
}

export type PostUserEditFetchResponse = 
| FetchResponse<{statusCode: string;
	data: UserEditOutputDto;}, 200> 
| ErrorResponse;

export const postUserEditPath = () => `/user/edit`;

export const postUserEdit = (requestContract: UserEditInputDto, options?: FetchArgsOptions):
  Promise<PostUserEditFetchResponse> => {
    const requestData = getApiRequestData<UserEditInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserEditPath()}`, requestData, options) as Promise<PostUserEditFetchResponse>;
}

export type GetUserExpenseTypesFetchResponse = 
| FetchResponse<{statusCode: string;
	data: ExpenseTypeDictionary;}, 200> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const getUserExpenseTypesPath = () => `/user/expense-types`;

export const getUserExpenseTypes = (options?: FetchArgsOptions):
  Promise<GetUserExpenseTypesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUserExpenseTypesPath()}`, options, {}) as Promise<GetUserExpenseTypesFetchResponse>;
}

export type GetUserPersonalDataFetchResponse = 
| FetchResponse<{statusCode: string;
	data: UserPersonalData;}, 200> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const getUserPersonalDataPath = () => `/user/personal-data`;

export const getUserPersonalData = (options?: FetchArgsOptions):
  Promise<GetUserPersonalDataFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUserPersonalDataPath()}`, options, {}) as Promise<GetUserPersonalDataFetchResponse>;
}

export type PostUserDeleteFetchResponse = 
| FetchResponse<{status: string;}, 200> 
| ErrorResponse;

export const postUserDeletePath = () => `/user/delete`;

export const postUserDelete = (requestContract: UserRemoveInputDto, options?: FetchArgsOptions):
  Promise<PostUserDeleteFetchResponse> => {
    const requestData = getApiRequestData<UserRemoveInputDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserDeletePath()}`, requestData, options) as Promise<PostUserDeleteFetchResponse>;
}

export type PostUserAddressFetchResponse = 
| FetchResponse<{statusCode: string;
	data: IdEntityDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postUserAddressPath = () => `/user/address`;

export const postUserAddress = (requestContract: AddressUserTyped, options?: FetchArgsOptions):
  Promise<PostUserAddressFetchResponse> => {
    const requestData = getApiRequestData<AddressUserTyped>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserAddressPath()}`, requestData, options) as Promise<PostUserAddressFetchResponse>;
}

export type PostUserSaveBankAccountFetchResponse = 
| FetchResponse<{statusCode: string;
	data: IdEntityDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postUserSaveBankAccountPath = () => `/user/save-bank-account`;

export const postUserSaveBankAccount = (requestContract: BankAccount, options?: FetchArgsOptions):
  Promise<PostUserSaveBankAccountFetchResponse> => {
    const requestData = getApiRequestData<BankAccount>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserSaveBankAccountPath()}`, requestData, options) as Promise<PostUserSaveBankAccountFetchResponse>;
}

export type PostUserSaveDocumentFetchResponse = 
| FetchResponse<{statusCode: string;
	data: IdEntityDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postUserSaveDocumentPath = () => `/user/save-document`;

export const postUserSaveDocument = (requestContract: Paperwork, options?: FetchArgsOptions):
  Promise<PostUserSaveDocumentFetchResponse> => {
    const requestData = getApiRequestData<Paperwork>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserSaveDocumentPath()}`, requestData, options) as Promise<PostUserSaveDocumentFetchResponse>;
}

export type PostUserSaveExpenseForceFetchResponse = 
| FetchResponse<{statusCode: string;
	data: IdEntityDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postUserSaveExpenseForcePath = () => `/user/save-expense(/:force)`;

export const postUserSaveExpenseForce = (requestContract: Expense, options?: FetchArgsOptions):
  Promise<PostUserSaveExpenseForceFetchResponse> => {
    const requestData = getApiRequestData<Expense>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserSaveExpenseForcePath()}`, requestData, options) as Promise<PostUserSaveExpenseForceFetchResponse>;
}

export type PostUserSaveIncomeFetchResponse = 
| FetchResponse<{statusCode: string;
	data: IdEntityDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postUserSaveIncomePath = () => `/user/save-income`;

export const postUserSaveIncome = (requestContract: Income, options?: FetchArgsOptions):
  Promise<PostUserSaveIncomeFetchResponse> => {
    const requestData = getApiRequestData<Income>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserSaveIncomePath()}`, requestData, options) as Promise<PostUserSaveIncomeFetchResponse>;
}

export type PostUserSavePersonalDataFetchResponse = 
| FetchResponse<{statusCode: string;
	data: IdEntityDto;}, 200> 
| FetchResponse<void, 400> 
| ErrorResponse;

export const postUserSavePersonalDataPath = () => `/user/save-personal-data`;

export const postUserSavePersonalData = (requestContract: UserPersonalBaseData, options?: FetchArgsOptions):
  Promise<PostUserSavePersonalDataFetchResponse> => {
    const requestData = getApiRequestData<UserPersonalBaseData>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserSavePersonalDataPath()}`, requestData, options) as Promise<PostUserSavePersonalDataFetchResponse>;
}
